<template>
  <v-container class="d-flex align-center status-btn" fluid>
    <div
      v-for="item in statusTypes"
      :key="item"
      class="d-flex align-center"
    >
      <v-btn
        :class="[status === item ? 'green' : 'white', mobile ? 'custom-btn-mobile' : 'custom-btn', `ga-farm-order_items-${item}`] "
        @click="statusHandler(item)"
      >{{ $t(`order_${item}`)( statusCount(item)) }}</v-btn>

      <div v-if="item!=='delivered'" :class="mobile ? 'next-mobile' : 'next'" />
    </div>

    <div class="ml-auto">
      <BackForwardBtn
        v-if="!mobile"
        :back-btn-label="backBtnLabel"
        :next-btn-label="nextBtnLabel"
        :on-click="backForward"
        :disabled="disabled"
      />
    </div>
  </v-container>
</template>

<script>
import BackForwardBtn from "@/components/farm/orderItems/BackForwardBtn.vue";

export default {
  components: { BackForwardBtn },
  props: {
    onChange: Function,
    backForward: Function,
    nextBtnLabel: String,
    backBtnLabel: String,
    disabled: Boolean
  },
  data() {
    return {
      mobile: this.$vuetify.breakpoint.xs,
      status: "unconfirmed",
      statusTypes: ["unconfirmed", "confirmed", "shipped"]
    };
  },
  computed: {
    store() {
      return this.$store.getters["orderItems/getState"];
    },
  },
  created() {
    const { query } = this.$route;
    if (query.status) this.status = query.status;

    this.statusHandler(this.status);
  },
  methods: {
    statusHandler(value) {
      this.status = value;
      this.onChange(value);
    },
    statusCount(status) {
      const counters = this.$store.state.orderItems.counters;

      if (status === "shipped") {
        return counters.shipped + counters.unloaded + counters.picked + counters.delivered;
      }

      if (status === "confirmed") {
        return counters.confirmed;
      }

      if (status === "unconfirmed") {
        return counters.unconfirmed;
      }

      return counters[status];
    }
  },
};
</script>

<style scoped>
.status-btn {
  overflow-x: auto;
}

.next {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #cccccc;
  margin: 0 0.5rem 0 0.5rem;
}

.next-mobile {
  width: 20px;
}

.custom-btn {
  width: 140px;
}

.custom-btn-mobile {
  width: 120px;
  border-radius: 50px;
}
</style>
